<div class="p-fluid p-text-center">
    <app-loader [enable]="isProgress">

    </app-loader>
</div>
